import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { EmployeeService } from 'src/app/feature-module/employees/service/employee.service';
import { ControlSettings } from 'src/app/shared/controls/ControlSettings';
import { EmployeeSearchResultItem } from '../../models/EmployeeSearchResultItem';


@Component({
  selector: 'app-employee-select-ctrl',
  templateUrl: './employee-select.component.html',
  styleUrls: ['./employee-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: EmployeeSelectComponent,
    multi: true
  }]
})
export class EmployeeSelectComponent implements ControlValueAccessor,OnInit  {

  constructor(
    protected controlContainer: ControlContainer, 
    private employeeService: EmployeeService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() hasInspectionRoleAllowedFlag = false;
  @Input() hasEmployeeTechnicianAllowedFlag = false;
  @Input() hasAssemblyRoleAllowedFlag = false;
  @Input() hasEmployeeMeritoricAllowedFlag = false;
  @Input() hasTechnicianRoleAllowedFlag = false;
  @Input() hasPartsHandlingEmployeeAllowedFlag = false;
  @Input() hasEmployeeExpertMeritoricAllowedFlag = false;
  @Input() hasEmployeeExpertTechnicianAllowedFlag = false;
  @Input() canBeProvisioned = false;
  @Output() valueChangeEvent = new EventEmitter<any>();
  @Output() displayTextChangeEvent = new EventEmitter<string>();
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};


  employeesList$: Observable<EmployeeSearchResultItem[]>;
  filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
    fields: ['name', 'surname', 'position']
  };
  
  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
    this.employeesList$ = this.employeeService.getAllEmployeesList().pipe(
      map( (x => x.filter(emp => 
        this.getUserForSpecificRole(emp)
      )) )
      );
  }

  getUserForSpecificRole(emp:EmployeeSearchResultItem) : boolean{
    let checkResult = 
    (!this.hasInspectionRoleAllowedFlag ||  emp.hasInspectionRoleAllowed ) &&
      (!this.hasTechnicianRoleAllowedFlag ||  emp.hasTechnicianRoleAllowed ) &&
      (!this.hasAssemblyRoleAllowedFlag ||  emp.hasAssemblyRoleAllowed ) &&
      (!this.hasEmployeeTechnicianAllowedFlag ||  emp.hasEmployeeTechnicianAllowed ) &&
      (!this.hasEmployeeMeritoricAllowedFlag ||  emp.hasEmployeeMeritoricAllowed ) &&
      (!this.hasEmployeeExpertTechnicianAllowedFlag ||  emp.hasEmployeeExpertTechnicianAllowed ) &&
      (!this.hasEmployeeExpertMeritoricAllowedFlag ||  emp.hasEmployeeExpertMeritoricAllowed ) &&
      (!this.hasPartsHandlingEmployeeAllowedFlag ||  emp.hasPartsHandlingEmployeeAllowed );

      if(this.canBeProvisioned){
        checkResult = checkResult && (emp.hasInspectionRoleAllowed || emp.hasTechnicianRoleAllowed 
            || emp.hasAssemblyRoleAllowed || emp.hasEmployeeTechnicianAllowed );
      }   

      return checkResult;
  }

  

  onChange(value: string) {
    this.valueChangeEvent.emit(value);
    let selectedText = '';
    if(value){
      selectedText = this.formControlDirective.valueAccessor['dataItem'].name + ' ' + this.formControlDirective.valueAccessor['dataItem'].surname;
    }
   
    this.displayTextChangeEvent.emit(selectedText);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
